import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { fetchAddressThunk } from 'slices/addressBook/thunk'
import { AppDispatch, RootState } from 'store'
import { SavedAddress } from 'types'
import { Gig } from 'types/collaboration'
import { generateGoogleMapUrl, getCombinedAddress } from 'utils/helpers'

interface StoresProps {
    gigs: Gig[],
    onSelect: (gig: Gig) => void,
    selectedGigs: (string | number)[]
}

export const StoreSelection: React.FC<StoresProps> = ({ gigs, onSelect, selectedGigs }) => {

    const dispatch: AppDispatch = useDispatch();

    const addressBook = useSelector((state: RootState) => state.addressBook.items);

    useEffect(() => {
        for (let gig of gigs) {
            if (gig.properties.address) {
                dispatch(fetchAddressThunk({ addressUUID: gig.properties.address }));
            }
        }
    }, [dispatch, gigs])


    return (
        <div className="gigs-list">
            {
                gigs.map((gig, i) => {

                    return (
                        <div className="gig-item" key={i} onClick={() => onSelect(gig)}>
                            <div className="gig-selection-checkbox-wrapper">
                                <input type='checkbox' checked={selectedGigs.includes(gig.id)} onChange={() => onSelect(gig)} className='form-check-input gig-selection-check-input' />
                            </div>
                            <div className="gig">
                                <div className='d-flex gap-2 w-70'>
                                    <div className="d-flex flex-column justify-content-center gap-2">
                                        <span className='gig-name clamp-2'>{gig.name}</span>
                                        {
                                            gig.properties.address &&
                                            <span className='gig-value text-muted'>{getCombinedAddress(addressBook[gig.properties.address]?.address)}</span>
                                        }
                                    </div>
                                </div>
                                {
                                    <div className="gig-cta visit-location-cta">
                                        <a onClick={(e) => e.stopPropagation()} href={generateGoogleMapUrl(addressBook[gig.properties.address]?.address.lat, addressBook[gig.properties.address]?.address.lng, addressBook[gig.properties.address]?.address?.place_id, gig.name)} target='_blank' rel='noreferral'>View Location</a>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}


export const SelectedStore: React.FC<{ gigs: Gig[] }> = ({ gigs }) => {

    const dispatch: AppDispatch = useDispatch();

    const addressBook = useSelector((state: RootState) => state.addressBook.items);

    useEffect(() => {
        for (let gig of gigs) {
            if (gig.properties.address) {
                dispatch(fetchAddressThunk({ addressUUID: gig.properties.address }));
            }
        }
    }, [dispatch, gigs])

    return (
        <div className="gigs-list">
            {
                gigs.map((gig, i) => {

                    return (
                        <div className="w-100" key={i}>
                            <div className="d-flex flex-column justify-content-center gap-2">
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className='gig-name clamp-2'>{gig.name}</span>

                                    <div className="gig-cta visit-location-cta px-2">
                                        <a className='map-btn' onClick={(e) => e.stopPropagation()} href={generateGoogleMapUrl(addressBook[gig.properties.address]?.address.lat, addressBook[gig.properties.address]?.address.lng, addressBook[gig.properties.address]?.address?.place_id, gig.name)} target='_blank' rel='noreferral'>
                                            <i className="mdi mdi-google-maps"></i>
                                        </a>
                                    </div>
                                </div>
                                {
                                    gig.properties.address &&
                                    <span className='gig-value text-muted'>{getCombinedAddress(addressBook[gig.properties.address]?.address)}</span>
                                }
                                <div className="d-flex flex-column">
                                    {
                                        gig.properties.phone ? (
                                            <div className="d-flex flex-column">
                                                <span className='fw-bold'>Contact:</span>
                                                <span>
                                                    {
                                                        gig.properties.contact_name ? (
                                                            `${gig.properties.contact_name}`
                                                        ) : null
                                                    }
                                                    <a href={"tel:" + gig.properties.phone} className='d-block'>
                                                        <i className="mdi mdi-phone-dial-outline me-1"></i>
                                                        {gig.properties.phone}
                                                    </a>
                                                </span>
                                            </div>
                                        ) : null
                                    }
                                    {
                                        gig.properties.business_hours &&
                                        <div className="d-flex flex-column mt-2">
                                            <span className='fw-bold'>Business Hours:</span>
                                            <span>{gig.properties.business_hours}</span>
                                        </div>
                                    }
                                </div>

                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}